import { useQuery } from '@tanstack/react-query';

import { DashboardKPIs } from '../../../../types/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getDashboardKpis } from '../../requests/getDashboardKpis';

export const useDashboardKpis = (options?: { enabled?: boolean }) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<DashboardKPIs> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'kpi-dashboard-data'],
    queryFn: () => getDashboardKpis(constructGet),
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'kpis'), ...rest };
};
